"use client";

import { useMemo } from "react";
import JsonEditorBase from "./JsonEditorBase";

interface JsonInputProps {
  label: string;
  description?: string;
  value: string | object;
  onChange: (value: string) => void;
  placeholder?: string;
}

// Convert value to string for display - handles both string and object values
const valueToString = (value: string | object): string => {
  if (value === null || value === undefined) return "{}";
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return "{}";
    }
  }
  return String(value);
};

export default function JsonInput({ label, description, value, onChange, placeholder }: JsonInputProps) {
  // Convert the value to a displayable string
  const displayValue = useMemo(() => valueToString(value), [value]);

  return (
    <JsonEditorBase
      label={label}
      description={description}
      value={displayValue}
      onChange={onChange}
      placeholder={placeholder || "{}"}
      minHeight="120px"
      // Uses default JSON validation - no custom validator needed
    />
  );
}
